import { render, staticRenderFns } from "./OrderAddCmp.vue?vue&type=template&id=2c375f6c&scoped=true"
import script from "./OrderAddCmp.vue?vue&type=script&lang=js"
export * from "./OrderAddCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c375f6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c375f6c')) {
      api.createRecord('2c375f6c', component.options)
    } else {
      api.reload('2c375f6c', component.options)
    }
    module.hot.accept("./OrderAddCmp.vue?vue&type=template&id=2c375f6c&scoped=true", function () {
      api.rerender('2c375f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimList/cmp/Add/OrderAddCmp.vue"
export default component.exports